<template>
  <v-responsive class="overflow-visible" :aspect-ratio="5 / 7">

    <input
      v-show="false"
      ref="upload"
      type="file" accept="image/*,image/heic,video/*,video/3gpp"
      @input="e => handleFile(e.target.files[0])"
    />

    <v-card
      class="absolute-fill d-flex justify-center align-center"
      v-bind:class="{ 'drop-zone': isDragging }"
      hover tile
      @drop.native.prevent="onDrop"
      @click="$refs.upload.click()"
    >
      <v-btn v-if="isDragging" icon x-large color="white">
        <v-icon x-large v-html="mdiUpload" />
      </v-btn>

      <template v-else-if="url">
        <video v-if="video" class="user-select-none absolute-fill" playsinline="" autoplay="autoplay" muted="muted" loop="loop" style="object-fit: cover; width: 100%; height: 100%;" draggable="false" :src="url" />
        <img v-else class="user-select-none absolute-fill" style="object-fit: cover; width: 100%; height: 100%;" draggable="false" :src="url" />
      </template>

      <div v-else class="text-center">
        <v-btn icon x-large color="primary">
          <v-icon x-large v-html="mdiPlusCircleOutline" />
        </v-btn>
      </div>
    </v-card>
  </v-responsive>
</template>


<style scoped>
.drop-zone {
  background-color: rgba(33, 150, 243, 0.5);
  animation: drop-zone-reveal .3s ease-in-out forwards;
}
@keyframes drop-zone-reveal {
  0% { opacity: 0; }
  50% { opacity: 0; }
  100% { opacity: 1; }
}

.btn {
  transition: opacity .15s;
}
.btn.is-hidden {
  opacity: 0;
  pointer-events: none;
}
.btn > button {
  text-shadow: -2px -2px 2px #FFF, -2px 0px 2px #FFF, -2px 2px 2px #FFF, 0px -2px 2px #FFF, 0px 2px 2px #FFF, 2px -2px 2px #FFF, 2px 0px 2px #FFF, 2px 2px 2px #FFF;
}
</style>


<script>
import { processImageFile } from '@/utils/image.js';
import { getMetadata } from '@/utils/video.js';
import { mdiClipboardArrowUp, mdiUpload, mdiPlusCircleOutline } from '@mdi/js';


export default {
  name: 'card-file-input',

  data() {
    return {
      isDragging: false,
      video: true,
      url: null
    }
  },

  created() {
    Object.assign(this, { mdiClipboardArrowUp, mdiUpload, mdiPlusCircleOutline });
  },

  mounted() {
    addEventListener('dragover', this.registerDrag);
  },

  beforeDestroy() {
    removeEventListener('dragover', this.registerDrag);
    clearInterval(this.checkIsDragging);
  },

  methods: {
    registerDrag(e) {
      e.preventDefault();
      this.isDragging = true;
      this.lastDrag = new Date().getTime();
      this.checkIsDragging = this.checkIsDragging || setInterval(
        () => {
          if (new Date().getTime() - this.lastDrag > 100) {
            clearInterval(this.checkIsDragging);
            this.isDragging = false;
            this.checkIsDragging = null;
            this.$forceUpdate();
          }
        },
        100
      );
    },

    async handleFile(file) {
      let data;
      try {
        data = await processImageFile(file);
        data.video = false;
      } catch (e) {
        const src = URL.createObjectURL(file);
        data = await getMetadata(src);
        data.url = src;
        data.video = true;
      }
      Object.assign(this, data);
      this.$emit('input', data);
    },

    onDrop(e) {
      const files = e.dataTransfer.files;
      if (files && files.length > 0) {
        const file = files[0];
        if (file.type.startsWith('image/'))
          this.handleFile(file);
        else if (file.type.startsWith('video/'))
          this.handleFile(file);
        else
          throw new VisibleError(`You can't add files of this type: ${file.type}`);
      }
    },

    reset() {
      this.url = null;
    }
  }
}
</script>
